export default {
  vendorBudget: {
    title: "Debug Proveedor-Presupuesto",
    buttons: {
      testIntegration: "Probar Integración",
      testing: "Probando...",
      clear: "Limpiar",
    },
    errors: {
      noUserOrEvent: "❌ No hay usuario o evento seleccionado",
      noUser: "❌ No hay usuario conectado",
      noEvent: "❌ No hay evento seleccionado",
      testError: "❌ Error durante la prueba",
    },
    messages: {
      startTest: "🧪 Prueba completa de la integración proveedor-presupuesto...",
      initialState: "📊 Estado inicial de los gastos...",
      initialFound: "Inicial: {{count}} gastos encontrados",
      creatingVendor: "👨‍💼 Creando un proveedor contratado con precio...",
      vendorData: "Datos del proveedor: {{data}}",
      vendorCreated: "✅ Proveedor creado con ID: {{id}}",
      waitingExpenses: "⏳ Esperando la creación de gastos...",
      checkingExpenses: "📊 Verificando gastos después de la creación del proveedor...",
      afterCreation: "Después de crear: {{count}} gastos encontrados",
      vendorExpenses: "Gastos del proveedor: {{count}}",
      expenseDetail: "{{index}}. {{title}}: {{amount}}€ (pagado: {{paid}})",
      checkingIds: "🔍 Verificando IDs de gastos en el proveedor...",
      vendorFound: "Proveedor encontrado: {{name}}",
      expenseId: "ID de gasto: {{id}}",
      depositExpenseId: "ID de depósito: {{id}}",
      notDefined: "no definido",
      vendorNotFound: "❌ Proveedor no encontrado después de la creación",
      cleanup: "🧹 Limpieza: eliminando proveedor de prueba...",
      vendorDeleted: "✅ Proveedor de prueba eliminado",
      finalCheck: "📊 Verificación final de gastos...",
      finalCount: "Final: {{count}} gastos encontrados",
      cleanupSuccess: "✅ Limpieza exitosa: todos los gastos de prueba han sido eliminados",
      cleanupWarning: "⚠️ Advertencia: algunos gastos de prueba podrían persistir",
    },
    noLogs: "No hay logs por ahora...",
  },
  contactsApi: {
    title: "Prueba de Contact Picker API",
    browser: "Navegador",
    https: "HTTPS",
    apiStatus: "Contact Picker API",
    enabled: "Habilitado",
    disabled: "Deshabilitado",
    supported: "Soportado",
    notSupported: "No soportado",
    technicalDetails: "Detalles técnicos",
    userAgent: "User Agent",
    platform: "Plataforma",
    language: "Idioma",
    cookiesEnabled: "Cookies habilitadas",
    yes: "Sí",
    no: "No",
    testButton: "Probar acceso a contactos",
    testing: "Probando...",
    error: "Error",
    contactsRetrieved: "Contactos obtenidos ({{count}})",
    noName: "Sin nombre",
    recommendations: "Recomendaciones",
    recommendation1: "• Use Chrome en Android o Safari en iOS para mejores resultados",
    recommendation2: "• Asegúrese de que el sitio esté en HTTPS",
    recommendation3: "• Permita el acceso a contactos cuando se lo pidan",
    recommendation4: "• Esta API solo funciona en móviles en la mayoría de los casos",
    errors: {
      notSupported: "La Contact Picker API no es soportada en este navegador",
      unknown: "Error desconocido al acceder a los contactos",
    },
    browserDetection: {
      chromeMobile: "Chrome Mobile",
      safariMobile: "Safari Mobile",
      chromeDesktop: "Chrome Desktop",
      safariDesktop: "Safari Desktop",
      firefox: "Firefox",
      edge: "Edge",
      unknown: "Navegador desconocido",
    },
  },
}; 